<div class="input-group" [class.focus]="inputgroupfocus">
    <span class="input-group-text pe-0" [class.disabled]="disabled"><i class="ds-icon-default-calendar"></i></span>
    <input type="datetime" [id]="id ? id : null" [name]="name ? name : null" class="form-control m-input" [(ngModel)]="jsdate" 
        bsDatepicker datePickerLuxonModifier [bsConfig]="{ adaptivePosition: true, showWeekNumbers: false }" 
        (focus)="dateFocus()" (blur)="dateBlur()" [disabled]="disabled" [readonly]="readonly" />
</div>